import React from 'react';

export const GoogleCalendarIconBorderless = () => (
	<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
		<g clipPath="url(#clip0_2230_19095)">
			<path
				d="M12.2106 3.78945L8.42113 3.36841L3.78953 3.78945L3.36841 8.00001L3.78945 12.2106L8.00001 12.7369L12.2106 12.2106L12.6316 7.89481L12.2106 3.78945Z"
				fill="white"
			/>
			<path
				d="M5.5169 10.3221C5.20218 10.1095 4.98426 9.79899 4.8653 9.38843L5.59586 9.08739C5.66218 9.34003 5.77794 9.53579 5.94322 9.67475C6.10746 9.81371 6.30746 9.88211 6.54114 9.88211C6.7801 9.88211 6.98538 9.80947 7.1569 9.66419C7.32842 9.51891 7.41481 9.33363 7.41481 9.10947C7.41481 8.88003 7.32426 8.69259 7.14322 8.54739C6.96218 8.40219 6.73482 8.32947 6.46322 8.32947H6.04114V7.60635H6.42002C6.6537 7.60635 6.85058 7.54323 7.01058 7.41691C7.17058 7.29059 7.25058 7.11795 7.25058 6.89795C7.25058 6.70219 7.17898 6.54635 7.03586 6.42955C6.89274 6.31275 6.71161 6.25379 6.49161 6.25379C6.27689 6.25379 6.10634 6.31067 5.98002 6.42539C5.8537 6.54011 5.7621 6.68115 5.70426 6.84747L4.98114 6.54643C5.0769 6.27483 5.25274 6.03483 5.51058 5.82747C5.7685 5.62011 6.09794 5.51587 6.49794 5.51587C6.7937 5.51587 7.06001 5.57275 7.29586 5.68747C7.53162 5.80219 7.7169 5.96115 7.85058 6.16323C7.98426 6.36635 8.05058 6.59379 8.05058 6.84635C8.05058 7.10427 7.9885 7.32211 7.86426 7.50107C7.74002 7.68003 7.58738 7.81683 7.40634 7.91267V7.95579C7.6453 8.05579 7.84001 8.20843 7.9937 8.41371C8.14633 8.61899 8.22314 8.86427 8.22314 9.15059C8.22314 9.43691 8.1505 9.69267 8.00522 9.91691C7.85994 10.1411 7.6589 10.3179 7.40418 10.4463C7.14842 10.5747 6.86106 10.64 6.5421 10.64C6.17266 10.6411 5.83162 10.5347 5.5169 10.3221Z"
				fill="#1A73E8"
			/>
			<path
				d="M9.99974 6.69687L9.20182 7.27687L8.80078 6.66847L10.2397 5.63055H10.7913V10.5263H9.99974V6.69687Z"
				fill="#1A73E8"
			/>
			<path
				d="M12.2105 16L16 12.2105L14.1053 11.3685L12.2105 12.2105L11.3685 14.1053L12.2105 16Z"
				fill="#EA4335"
			/>
			<path
				d="M2.94739 14.1053L3.78947 16H12.2105V12.2106H3.78947L2.94739 14.1053Z"
				fill="#34A853"
			/>
			<path
				d="M1.26312 0C0.56528 0 0 0.56528 0 1.26312V12.2105L1.89472 13.0526L3.78944 12.2105V3.78944H12.2105L13.0526 1.89472L12.2106 0H1.26312Z"
				fill="#4285F4"
			/>
			<path
				d="M0 12.2106V14.7369C0 15.4348 0.56528 16 1.26312 16H3.78944V12.2106H0Z"
				fill="#188038"
			/>
			<path
				d="M12.2103 3.78953V12.2106H15.9997V3.78953L14.105 2.94745L12.2103 3.78953Z"
				fill="#FBBC04"
			/>
			<path
				d="M15.9997 3.78944V1.26312C15.9997 0.5652 15.4344 0 14.7366 0H12.2103V3.78944H15.9997Z"
				fill="#1967D2"
			/>
		</g>
		<defs>
			<clipPath id="clip0_2230_19095">
				<rect width="16" height="16" fill="white" />
			</clipPath>
		</defs>
	</svg>
);
